// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__RtUqF","headerImg":"styles_headerImg__Icp8f","imgLine":"styles_imgLine__sIbwu","createImageWrap":"styles_createImageWrap__STOoc","title":"styles_title__92GK2"};